import Svg, {Path, Polygon, Rect, Text} from 'react-native-svg'

import {type Props, useCommonSVGProps} from './common'
import {createSinglePathSVG} from './TEMPLATE'

export const Mark = createSinglePathSVG({
  path: 'M6.335 4.212c2.293 1.76 4.76 5.327 5.665 7.241.906-1.914 3.372-5.482 5.665-7.241C19.319 2.942 22 1.96 22 5.086c0 .624-.35 5.244-.556 5.994-.713 2.608-3.315 3.273-5.629 2.87 4.045.704 5.074 3.035 2.852 5.366-4.22 4.426-6.066-1.111-6.54-2.53-.086-.26-.126-.382-.127-.278 0-.104-.041.018-.128.278-.473 1.419-2.318 6.956-6.539 2.53-2.222-2.331-1.193-4.662 2.852-5.366-2.314.403-4.916-.262-5.63-2.87C2.35 10.33 2 5.71 2 5.086c0-3.126 2.68-2.144 4.335-.874Z',
})

export function Full(
  props: Omit<Props, 'fill' | 'size' | 'height'> & {
    markFill?: Props['fill']
    textFill?: Props['fill']
  },
) {
  const {fill, size, style, gradient, ...rest} = useCommonSVGProps(props)
  const ratio = 123 / 555

  return (
    <Svg
      fill="none"
      {...rest}
      viewBox="0 0 300 73"
      width={size}
      height={size * ratio}
      style={[style]}>
      {gradient}
      {/*<Path
        fill={props.markFill ?? fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.821 7.673C112.575-.367 130-6.589 130 13.21c0 3.953-2.276 33.214-3.611 37.965-4.641 16.516-21.549 20.729-36.591 18.179 26.292 4.457 32.979 19.218 18.535 33.98-27.433 28.035-39.428-7.034-42.502-16.02-.563-1.647-.827-2.418-.831-1.763-.004-.655-.268.116-.831 1.763-3.074 8.986-15.07 44.055-42.502 16.02C7.223 88.571 13.91 73.81 40.202 69.353c-15.041 2.55-31.95-1.663-36.59-18.179C2.275 46.424 0 17.162 0 13.21 0-6.59 17.426-.368 28.18 7.673 43.084 18.817 59.114 41.413 65 53.54c5.886-12.125 21.917-34.722 36.821-45.866Z"
      />
      <Path
        fill={props.textFill ?? fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="m454.459 63.823 24.128-25.056h32.638l4.825 15.104c3.561 11.357 6.664 22.598 9.422 33.72 2.527-9.6 5.744-20.84 9.536-33.603l4.826-15.221H555l-22.864 65.335c-2.413 6.673-5.4 11.475-9.192 14.168-3.791 2.693-9.192 3.98-16.315 3.98-2.413 0-4.481-.117-6.319-.352v-11.59h5.514c6.549 0 9.767-4.099 9.767-9.719 0-2.81-.92-6.908-2.758-12.177l-17.177-49.478-22.239 22.665L497.2 99.184h-16.545l-17.234-28.101-8.962 9.133v18.968h-14.246V15.817h14.246v48.006Zm-48.373-26.46c16.889 0 25.622 6.79 26.196 20.49h-13.673c-.344-7.377-4.595-9.954-12.523-9.954-6.894 0-10.341 2.342-10.341 7.026 0 4.215 2.987 6.089 9.881 7.377l7.469 1.17c14.361 2.694 20.566 8.08 20.566 18.384 0 12.176-9.652 18.967-26.311 18.967-17.235 0-26.311-6.908-27.116-20.842h14.132c.804 7.494 4.481 10.304 13.213 10.304 7.813 0 11.72-2.459 11.72-7.26 0-4.332-2.758-6.44-11.605-7.962l-6.778-1.17c-12.983-2.224-19.418-8.313-19.418-18.265 0-11.358 8.847-18.266 24.588-18.266ZM270.534 76.351c0 7.61 3.677 11.474 11.145 11.474 7.008 0 13.212-5.268 13.213-15.22v-33.84h14.476v60.418h-14.016v-8.782c-4.481 6.791-10.686 10.187-18.614 10.187-12.523 0-20.68-7.728-20.68-21.778V38.767h14.476v37.585Zm75.432-38.99c8.961 0 16.085 3.045 21.37 9.016s7.928 13.933 7.928 23.651v3.513h-44.35c1.034 10.42 6.664 15.572 15.396 15.572 6.663 0 11.144-2.927 13.557-8.664h13.903c-3.103 12.294-13.443 20.139-27.575 20.139-8.847 0-15.971-2.927-21.371-8.664-5.4-5.737-8.157-13.348-8.157-22.95 0-9.483 2.643-17.094 8.043-22.949 5.4-5.737 12.409-8.664 21.256-8.664ZM195.628 15.817c17.809 0 26.426 9.251 26.426 21.545 0 8.196-3.677 14.168-10.915 17.914 9.306 3.396 14.247 11.24 14.247 20.022 0 14.87-9.767 23.886-28.494 23.886h-38.26V15.817h36.996Zm51.264 83.367h-14.477V15.817h14.477v83.367ZM174.143 86.07h21.944c8.732 0 13.443-4.098 13.443-11.474 0-7.728-4.481-11.592-13.443-11.592h-21.944V86.07Zm171.708-37.233c-7.928 0-13.443 4.683-14.822 14.401h29.758c-1.264-8.781-6.549-14.401-14.936-14.401Zm-171.708 1.756h20.336c7.927 0 12.178-4.215 12.178-11.24 0-6.44-4.366-10.539-12.178-10.539h-20.336v21.779Z"
      />*/}
      <Polygon
        fill="#61a38b"
        points="36.76 37.88 46.47 36.99 54.01 11.55 66.73 11.55 46.47 60.25 36.76 37.88"
      />
      <Rect fill="#28004e" width="73" height="73" rx="15" ry="15" />
      <Polygon
        fill="#fff"
        points="21.58 17.23 9.28 17.23 27.58 60.13 34.2 48.88 21.58 17.23"
      />
      <Path
        fill="#61a38b"
        d="M39.12,37.67l6.19-.57c.7-.06,1.29-.55,1.49-1.22l7.35-24.27c.22-.73.88-1.23,1.64-1.23h8.87c1.22,0,2.05,1.24,1.58,2.37l-19.33,46.43c-.48,1.17-1.35,1.06-2.65,1.06l-6.56-20.19c-.47-1.07.25-2.28,1.42-2.39Z"
      />
      <Path
        fill="#fff"
        d="M30.58,28.15l3.78-5.98c1.46-2.31,4.96-1.85,5.77.77l4.14,13.49,5.58-19.2h11.88l-17.46,43.02-13.68-32.1Z"
      />
      <Path
        fill="#1df2ba"
        d="M34.55,37.34l2.99-4.73c1.47-2.32,4.99-1.85,5.79.77l.93,3.04,7.54-26.05h12.72l-20.26,49.87-9.71-22.91Z"
      />

      <Text
        x="100.000"
        y="60"
        fill={props.textFill ?? fill}
        font-size="60"
        font-weight="700"
        font-family="Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Arial, 'DejaVu Sans', sans-serif">
        W Social
      </Text>
    </Svg>
  )
}
